import styled from 'styled-components'
import { isMobile } from '../../services/breakpoints.service'
import { breakpoints } from '../../constants'
import { PRIMARY_COLOR, PRIMARY_LIGHT } from '../../styles/colors.style'

export const LineTitleWrapper = styled.span`
	align-items: center;
	display: flex;
	flex-direction: row;
	font-size: 2rem;
	margin-top: 9px;
	width: 100%;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		font-size: 1.3rem;
	}
`

export const LineTitleLeft = styled.span`
	flex-grow: 1;
	height: 1px;
	margin-right: 7px;
`

export const LineTitleRight = styled.span`
	flex-grow: 1;
	height: 1px;
	margin-left: 7px;
`

export const StyledContainer = styled.div`
	position: relative;
	bottom: 130px;
	width: 250px;

	.image-container {
		height: 250px;

		& > img {
			width: 100%;
			height: 100%;
			object-fit: fill;
			display: block;
			border-radius: 20px;
		}
	}

	.gosht-container {
		height: 350px;
	}

	.info-container {
		padding: 20px;
		padding: 20px;
		position: absolute;
		background-color: #fff;
		width: 100%;
		top: 220px;
		border-radius: 20px;
	}

	.name {
		font-size: ${isMobile() ? 2 : 1.7}rem;
		height: 60px;
		font-weight: 600;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		text-overflow: ellipsis;
		overflow: hidden;
		line-height: 20px;
		text-align: justify;
	}

	.points {
		font-size: 1.2em;
		font-weight: bold;
	}

	.footer-container {
		display: flex;
		flex: 1;
		flex-direction: row;
		margin-top: 10px;
		height: 50px;
		align-items: center;
	}

	.label-price-container {
		display: flex;
		flex: 1;
		margin: 0;
		display: flex;
		flex-direction: column;
		justify-content: space-around;

		span {
			line-height: normal;
		}
	}

	.startingAt {
		font-size: ${isMobile() ? 2 : 1.5}rem;
	}

	.btn-details {
		display: flex;
		background-color: #fff;
		color: ${PRIMARY_COLOR};
		font-weight: lighter;
		padding: 10px 15px;
		border: 2px solid ${PRIMARY_LIGHT};
		border-radius: 6px;
		font-size: 13px;
		cursor: pointer;
		align-content: center;
		font-weight: normal;
		justify-content: center;
		transition: 0.5s background;
		height: -webkit-fill-available;
		align-items: center;
		width: 110px;

		&:hover {
			background-color: ${PRIMARY_LIGHT};
			color: #fff;
		}
	}
`
